/** 论文台：独立产品 · 自有套餐代付 */
export const BRAND = {
  name: '论文台',
  product: '论文台',
  tagline: 'MBA 论文写作',
  loader: '论文台加载中…',
  host: 'thesis.mengzhiji.net',
  url: 'https://thesis.mengzhiji.net',
} as const;

export const TERM = {
  work: '论文',
  works: '论文',
  createWork: '新建论文',
  yourWorks: '我的论文',
  workSettings: '论文设置',
  openWorkSettings: '打开论文设置',
  outline: '目录',
  volume: '篇',
  chapter: '章',
  scene: '节',
  assistant: '开题助手',
  navWorks: '论文',
  navSeries: '专题',
  navPrompts: '提示词',
} as const;
